import React from 'react';
import { useTranslation } from 'react-i18next';

import DialogCustom from 'commons/DialogCustom';
import FormInput from 'commons/Form/FormInput';
import IosSwitch from 'commons/IosSwitch';
import Text from 'commons/Text';
import API from 'configs/API';
import { TESTID } from 'configs/Constant';

import useDialogEditArrtistProfile from './hook/useDialogEditArrtistProfile';
import useStyles from './styles';

const DialogEditArtistProfile = ({
  isShowDialog,
  editedYear,
  editedToYear,
  editedDescription,
  editedExhibitionLink,
  editedIsPublic,
  selectedExhibition,
  setEditYear,
  setEditToYear,
  setEditDescription,
  setEditedIsPublic,
  setEditedExhibitionLink,
  setIsShowDialogEdit,
  getListExhibition,
  isSoloExhibition,
  dialogTitle,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    wrongExhibitionLink,
    wrongYear,
    wrongToYear,
    isFormValid,
    handleChangeYear,
    handleChangeToYear,
    handleChangeDescription,
    handleSwitchChange,
    handleCancelExhibition,
    handleChangeLink,
    handleSubmitExhibition,
  } = useDialogEditArrtistProfile(
    editedYear,
    editedToYear,
    editedDescription,
    editedExhibitionLink,
    setEditYear,
    setEditToYear,
    setEditDescription,
    setEditedIsPublic,
    setIsShowDialogEdit,
    setEditedExhibitionLink,
    selectedExhibition,
    editedIsPublic,
    getListExhibition,
  );

  return (
    <DialogCustom
      isShowDialog={isShowDialog}
      textCancel={t('cancel')}
      dialogTitle={dialogTitle}
      textSubmit={t('save')}
      disabledButton={!isFormValid}
      onCancel={handleCancelExhibition}
      onSubmit={() =>
        isSoloExhibition
          ? handleSubmitExhibition(API.AUTH.SOLO_EXHIBITION.DETAIL(selectedExhibition?.id))
          : handleSubmitExhibition(API.AUTH.GROUP_EXHIBITION.DETAIL(selectedExhibition?.id))
      }
      maxWidth={'md'}
      fullWidth
    >
      <div className={classes.wrapInput}>
        <FormInput
          value={editedYear}
          label={t('from')}
          placeholder={t('enter_year_leave_blank_if_unknown')}
          onChange={handleChangeYear}
          InputProps={{
            inputProps: { type: 'number', step: '1' },
          }}
          error={editedYear ? wrongYear : false}
          helperText={editedYear && wrongYear && t('please_enter_correct_year')}
          textFieldStyle={classes.textFieldStyle}
          wrapFormInputStyle={classes.wrapFormYearInput}
        />
        <FormInput
          value={editedToYear}
          label={t('to')}
          placeholder={t('enter_year_leave_blank_if_unknown')}
          onChange={handleChangeToYear}
          InputProps={{
            inputProps: { type: 'number', step: '1' },
          }}
          error={editedToYear ? wrongToYear : false}
          helperText={editedToYear && wrongToYear && t('please_enter_correct_year')}
          textFieldStyle={classes.textFieldStyle}
          wrapFormInputStyle={classes.wrapFormYearInput}
        />
      </div>

      <FormInput
        value={editedDescription}
        label={t('description')}
        placeholder={t('write_something_to_describe')}
        onChange={handleChangeDescription}
        textFieldStyle={classes.textFieldStyle}
        wrapFormInputStyle={classes.wrapFormDescriptionInput}
      />

      <FormInput
        value={editedExhibitionLink}
        label={t('exhibition_link')}
        placeholder={t('enter_an_url')}
        onChange={handleChangeLink}
        error={editedExhibitionLink ? wrongExhibitionLink : false}
        helperText={editedExhibitionLink && wrongExhibitionLink && t('please_enter_correct_link')}
        textFieldStyle={classes.textFieldStyle}
        testid={TESTID.FORM_INPUT_EDIT_ARTIST_PROFILE}
      />
      <div className={classes.wrapIosSwitch}>
        <IosSwitch
          isChecked={editedIsPublic}
          onSwitchChange={handleSwitchChange}
        />
        <Text
          className={classes.textPublicProfile}
          mt={12}
        >
          {editedIsPublic ? t('public_on_profile') : t('private')}
        </Text>
      </div>
    </DialogCustom>
  );
};

export default DialogEditArtistProfile;
